<template>
  <div class="text-center">
    Загрузка {{ dot }}
  </div>
</template>

<script>
export default {
  props: {},
  data: () => ({
    dot: '',
    time: 0
  }),
  computed: {
    loading() {
      return this.dot
    }
  },
  mounted() {
    const interval = setInterval(() => {
      this.dot += '.'
      this.time++
      if (this.time > 25) {
        clearInterval(interval)
      }
      if (this.dot.length > 3) {
        this.dot = ''
      }
    }, 450)
  }
}
</script>